import React, { useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
// import Navbar from '../components/navbar/Navbar';
// add styles
import styles from './Header.module.scss'
const Header = () => {

    return (
        <header>
            <nav>
                <h1>The Evan Project</h1>

                <NavLink to="/" className={styles.navLink} style={({ isActive }) => ({
                    borderBottom: isActive ? '3px solid red' : '',
                })}>Home</NavLink>
{/* 
                <NavLink to="about" className={styles.navLink} style={({ isActive }) => ({
                    borderBottom: isActive ? '3px solid red' : '',
                })}>About</NavLink> */}

                <NavLink to="blog" className={styles.navLink} style={({ isActive }) => ({
                    borderBottom: isActive ? '3px solid red' : '',
                })}>Blog</NavLink>

                {/* <NavLink to="todolist" className={styles.navLink} style={({ isActive }) => ({
                    borderBottom: isActive ? '3px solid red' : '',
                })}>Todo List</NavLink> */}

            </nav>
        </header >
    )
}

export default Header;